import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'

import ChatPreviewBlock from 'Components/ChatPreviewBlock'
import CreateMsg from 'Components/CreateMsg'
import { fetchHelper } from 'tools/FetchHelper'
import enums from 'enums'

import './index.css'

const StickerReply = (props) => {
	const { t } = useTranslation();

	const [isFetching, setFetching] = useState(false)
	const [isUpdating, setUpdating] = useState(false)
	const [messages, setMsg] = useState([])


	const updateBotStickerReply = async () => {
		setUpdating(true)

		try {
			const result = await fetchHelper.post(`/channel/${props.channelId}/bot/stickerReply`, {
				reply: messages
			}, {
				fetchQAbot: true
			});
			const res = result.data

			if (res.status === "OK") {
				setUpdating(false)
			} else {
				throw new Error(result.errorMessage);
			}
		} catch (error) {
			setUpdating(false)
			console.log('update bot stickerReply fail', error.message)
		}
	}

	useEffect(() => {
		const fetchBotStickerReply = async () => {
			setFetching(true)
			try {
				const result = await fetchHelper.get(`/channel/${props.channelId}/bot/stickerReply`, {
					fetchQAbot: true
				});
				const res = result.data
				if (res.status === "OK") {
					setMsg(res.data.reply)
					setFetching(false)
				} else {
					throw new Error(result.errorMessage);
				}
			} catch (error) {
				console.log('get bot stickerReply fail', error.message)
			}
		}

		fetchBotStickerReply()

	}, [props.channelId])

	return (
		<div className="greeting-page">
			<div className="page-title">
				<Link to={`/console/channel/${props.channelId}/bot`}>{t('bot.title')}</Link>
				<i className="far fa-chevron-right" />
				{t('bot.stickerReply')}
			</div>
			<div className="page-des">{t('bot.stickerReplyDes')}</div>
			<div className="bot-setting-content">
				<div className="setting-part">
					{isFetching ?
						<div className="icon-loading">
							<i className="fal fa-spinner-third fa-spin" />
						</div> :
						<>
							<CreateMsg
								{...props}
								messages={messages}
								onChange={(messages) => setMsg(messages)}
								limit={5}
								fileUploadFrom={enums.FileUploadFrom.bot}
							/>
							<div className="button-group">
								<button className="c-btn">{t('cancel')}</button>
								<button className="c-btn c-btn--primary"  onClick={() => {
									if (isUpdating) return;
									updateBotStickerReply()
								}}>
									{isUpdating ?
										<i className="fal fa-spinner-third fa-spin" /> :
										t('save')
									}
								</button>
							</div>
						</>
					}

				</div>
				<div className="preview-part">
					<div className="sub-title">{t('preview')}</div>
					<ChatPreviewBlock
						{...props}
						messages={messages}
						sender={{
							type: 'bot'
						}}
					/>
				</div>
			</div>
			<div className="button-group">
				<button className="c-btn">{t('cancel')}</button>
				<button className="c-btn c-btn--primary" onClick={() => {
					if (isUpdating) return;
					updateBotStickerReply()
				}}>
					{isUpdating ?
						<i className="fal fa-spinner-third fa-spin" /> :
						t('save')
					}
				</button>
			</div>
		</div>
	)
}

export default StickerReply;